module.exports = __webpack_public_path__ + "img/tv.ee26205e.svg";